import {Component, OnDestroy, OnInit} from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {
  currentMessage = 'Enviando solicitud'
  messages: string[] = [
    'Realizando operación',
    'Ya casi terminamos',
    'Espera un momento más',
    'Unos segundos más',
    'Estamos por terminar'
  ]
  private timers: ReturnType<typeof setTimeout>[] = []

  ngOnInit() {
    this.generateMessage()
  }

  // Si la capa se cierra antes, que los mensajes pendientes no sigan corriendo.
  ngOnDestroy() {
    this.timers.forEach(t => clearTimeout(t))
    this.timers = []
  }

  generateMessage () {
    const pasos: [number, number][] = [[0, 1500], [1, 4000], [2, 6000], [3, 10000], [4, 15000]]
    this.timers = pasos.map(([indice, espera]) => setTimeout(() => {
      this.currentMessage = this.messages[indice]
    }, espera))
  }

}
